<template lang="pug">
  
  .supervisor(:class="classObject"): .content: .client {{ $t('task.supervisor') }}

</template>

<script>
import cellable from './mixins/cellable'

export default{
  mixins: [cellable],
}
</script>